import { FlattenSimpleInterpolation, css } from 'styled-components';
import { TypesSelect } from '../../types/TypesSelect';
import { colors } from '../../constants/Colors';
import { typography } from '../../helpers/styles/typography';
import { SelectProps } from '../../types/Select/SelectProps';

const stylesOptionName: Record<TypesSelect, FlattenSimpleInterpolation> = {
    [TypesSelect.TRANSPARENT]: css`
    color: ${colors.greyDark};
  `,
    [TypesSelect.DEFAULT]: css`
    color: ${colors.greyDark};
    ${typography(5)};
  `,
    [TypesSelect.OUTLINE]: css`
    color: ${colors.greyDark};
    ${typography(5)}
  `,
};

const stylesDisabledOptionName: Record<TypesSelect, FlattenSimpleInterpolation> = {
    [TypesSelect.TRANSPARENT]: css`
    color: ${colors.greyDark};
  `,
    [TypesSelect.DEFAULT]: css`
    color: ${colors.greyDark};
  `,
    [TypesSelect.OUTLINE]: css`
    color: ${colors.greyDark};
  `,
};

export const applyStyleOptionNameByType = ({ selectType, disabled }: Pick<SelectProps, 'selectType' | 'disabled'>) => {
    if (disabled) {
        return stylesDisabledOptionName[selectType];
    }

    return stylesOptionName[selectType];
};
